const SET_COMMUNITY_CONTENT = (state, payload) => {
  state.currentOrigin.communityContent = payload.communityContent.results.map(
    (i) => i.item
  );
};

export default SET_COMMUNITY_CONTENT;
